import { db } from "../lib/firebase";
import { doc, getDoc, setDoc, Timestamp } from "firebase/firestore";
import { AdminDailyMenu, RateCardConfig } from "../types/index";

// --- Rate Card & Config Management ---

export const getRateCard = async (): Promise<RateCardConfig> => {
  // FIX: Point to the same document that Checkout.tsx reads
  const ref = doc(db, "settings", "global"); 
  const snap = await getDoc(ref);
  
  // Default Config including UPI & Delivery Settings
  const defaults: RateCardConfig = {
    // 1. Platform Fees
    platformFee: 5,
    platformFeeLow: 3,
    platformFeeMid: 5,
    platformFeeHigh: 10,
    platformFeeThresholdLow: 50,
    platformFeeThresholdHigh: 200,
    customerPlatformFeeShare: 0.4,
    
    // 2. Commissions
    gstPercentage: 5,
    chefCommissionPercentage: 20,
    
    // 3. Delivery Logic
    deliveryThreshold: 5,
    deliveryFeeBelowThreshold: 40,
    deliveryFeeAboveThreshold: 20,
    maxDeliveryDistanceKm: 15,
    
    // 4. Payment Settings
    // FIX: Using standardized keys matching Checkout & Admin UI
    upiId: "ruchira@upi", 
    merchantName: "Ruchira Home Food",
    adminUpiId: "ruchira@upi", // Legacy backup
    upiEnabled: true,
    
    // Legacy support
    deliveryFeeBase: 40,
    deliveryFeePerKm: 10
  };

  if (snap.exists()) {
    // Merge saved data with defaults to ensure new fields exist
    return { ...defaults, ...snap.data() } as RateCardConfig;
  } else {
    // Initialize the document if it doesn't exist
    await setDoc(ref, defaults);
    return defaults;
  }
};

export const updateRateCard = async (config: RateCardConfig): Promise<void> => {
  // FIX: Write to the same 'settings/global' path
  const ref = doc(db, "settings", "global");
  await setDoc(ref, config, { merge: true });
};

// --- DAILY MENU FUNCTIONS (Unchanged) ---

export const getLocalDateId = (date: Date) => {
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - (offset*60*1000));
    return localDate.toISOString().split('T')[0];
};

export const getDailyMenu = async (dateId: string): Promise<AdminDailyMenu | null> => {
    const docRef = doc(db, "admin_daily_menu", dateId);
    const snap = await getDoc(docRef);
    if (snap.exists()) {
        return snap.data() as AdminDailyMenu;
    }
    return null;
};

export const saveDailyMenu = async (dateId: string, data: Partial<AdminDailyMenu>) => {
    const docRef = doc(db, "admin_daily_menu", dateId);
    const payload: Record<string, any> = {
        ...data,
        id: dateId,
        updatedAt: Timestamp.now()
    };
    // Replace the fields we send (notably the whole `kitchenMenus` map) instead of
    // deep-merging them. With { merge: true }, a kitchen removed from the draft
    // (its last item deleted) stayed in Firestore and "reappeared" on reload.
    Object.keys(payload).forEach((k) => payload[k] === undefined && delete payload[k]);
    await setDoc(docRef, payload, { mergeFields: Object.keys(payload) });
};